import { EvaluationSteps } from './constants'

export const isLastStep = (step: number) => step >= EvaluationSteps.CONFIG
